import styled, {css} from 'styled-components';

import {colors, transition} from '@app/styles/theme';
import {Table} from '@shared/ui/Table2.0';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const HeaderCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const HeaderTop = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
`;

export const TaxpayerTitle = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;

    h2 {
        margin: 0;
        color: ${colors.textPrimary};
        font-size: 24px;
        line-height: 1.2;
    }

    span {
        color: ${colors.textSecondary};
        font-size: 14px;
    }
`;

export const ContentCard = styled.div`
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const TabsContentCard = styled(ContentCard)`
    padding: 20px 0;
    display: flex;
    flex-direction: column;
`;

export const Controls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
    padding: 0 20px;
    background: ${colors.white};
`;

export const ActionGroup = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
`;

const optionButtonBase = css<{isActive?: boolean}>`
    border: 1px solid ${({isActive}) => (isActive ? colors.brandPrimary : colors.border)};
    background: ${({isActive}) => (isActive ? colors.brandPrimary : colors.white)};
    color: ${({isActive}) => (isActive ? colors.white : colors.textPrimary)};
    border-radius: 8px;
    padding: 10px 16px;
    min-width: 140px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all ${transition.duration};

    &:hover {
        border-color: ${colors.brandDark};
        color: ${({isActive}) => (isActive ? colors.white : colors.brandDark)};
    }
`;

export const FilterButton = styled.button<{isActive?: boolean}>`
    ${optionButtonBase};
    border-radius: 999px;
`;

export const SearchBox = styled.div`
    width: 100%;
    max-width: 400px;
`;

export const ContractorsTable = styled(Table)`
    background: ${colors.background};
`;

export const Chart = styled.div`
    height: 280px;
    margin-top: 20px;
`;

export const ChartLegend = styled.div`
    display: flex;
    align-items: center;
    gap: 32px;
    flex-wrap: wrap;
`;

export const ChartLegendItem = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: ${colors.textPrimary};
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
`;

export const ChartLegendSwatch = styled.span<{color: string}>`
    width: 20px;
    height: 20px;
    border-radius: 3px;
    background: ${({color}) => color};
    flex: 0 0 auto;
`;

export const Statements = styled.div`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    padding: 0 20px;
`;

export const Statement = styled.div`
    padding: 12px 16px;
    border: 1px solid ${colors.brandPrimary};
    border-radius: 8px;
    min-width: 180px;

    span {
        display: block;
        margin-bottom: 6px;
    }
`;

export const NotificationsDateTimeCell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const NotificationsDownloadButton = styled.button`
    border: 0;
    background: transparent;
    color: ${colors.brandPrimary};
    cursor: pointer;
    padding: 0;
    font: inherit;
`;

export const NotificationsDrawerHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
`;

export const NotificationsDrawerLoading = styled.div`
    min-height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const NotificationsDetailsBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-height: calc(100vh - 180px);
`;

export const NotificationsDetailsDate = styled.div`
    text-align: right;
    color: ${colors.textSecondary};
    font-size: 12px;
`;

export const NotificationsAttachmentList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const NotificationsAttachmentItem = styled.button`
    border: 0;
    background: transparent;
    color: ${colors.brandPrimary};
    cursor: pointer;
    padding: 0;
    text-align: left;
    font: inherit;
`;

export const NotificationsPreviewFrame = styled.iframe`
    flex: 1 1 auto;
    min-height: 500px;
    width: 100%;
    border: 1px solid ${colors.border};
    border-radius: 8px;
    background: ${colors.white};
`;

export const NotificationsEmptyMessage = styled.div`
    color: ${colors.textSecondary};
`;
